import Dispatch from "nexia_mobile/flux_like/dispatch";
import { setValueAtPath } from "nexia_mobile/flux_like/store";

Dispatch.on("APP_IS_CURRENTLY_POLLING_ENROLLMENT_STATUS", () => {
  setValueAtPath("currentlyPollingEnrollmentStatus", true);
});

Dispatch.on("APP_IS_NO_LONGER_POLLING_ENROLLMENT_STATUS", () => {
  setValueAtPath("currentlyPollingEnrollmentStatus", false);
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/enrollment.js